<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Delagated Person Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <v-row>
        <v-col lg="5">
          <label>Name </label>
          <v-text-field
            v-model.trim="delagatedPerson.name"
            :error-messages="handleFieldErrors($v.delagatedPerson.name)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="3">
          <label>Age </label>
          <v-text-field
            v-model.trim="delagatedPerson.age"
            :error-messages="handleFieldErrors($v.delagatedPerson.age)"
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="4">
          <label>Sex </label>
          <v-radio-group
            :error-messages="handleFieldErrors($v.delagatedPerson.sex)"
            v-model="delagatedPerson.sex"
            row
          >
            <v-radio label="Male" :value="1"></v-radio>
            <v-radio label="Female" :value="2"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="5">
          <label>Relationship </label>
          <v-select
            :items="[
              { id: 1, text: 'Family' },
              { id: 2, text: 'Friends' },
            ]"
            v-model="delagatedPerson.relationship"
            :error-messages="handleFieldErrors($v.delagatedPerson.relationship)"
            item-text="text"
            item-value="id"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col lg="7"> </v-col>
      </v-row>

      <v-row> </v-row>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn
        v-if="delagatedPerson.id"
        @click.prevent="emitData"
        class="form-btn"
      >
        <v-icon left>mdi-chevron-right-circle-outline</v-icon>
        Update
      </v-btn>
      <v-btn v-else @click.prevent="emitData" class="form-btn">
        <v-icon left>mdi-chevron-right-circle-outline</v-icon>
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
export default {
  components: { FormRequireNoti },
  mixins: [ValidationMixin],
  props: {
    delagatedPerson: {
      type: Object,
      default: () => {
        return {
          name: null,
          age: null,
          sex: "",
          relationship: null,
        };
      },
    },
  },
  data: () => ({}),
  validations: {
    delagatedPerson: {
      name: {
        required,
      },
      age: {
        required,
      },
      sex: {
        required,
      },
      relationship: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    emitData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          patient_id: this.$route.params.patient_id,
          id: this.delagatedPerson.id,
          name: this.delagatedPerson.name,
          age: this.delagatedPerson.age,
          sex: this.delagatedPerson.sex,
          relationship: this.delagatedPerson.relationship,
        };

        const formData = new FormData();
        for (var key in data) {
          formData.append(key, data[key]);
        }
        this.$emit("emitData", formData);

        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
